/* app/js/src/components/graphics/edit/fields/colors.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.colors-container {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
icn-color-component:not(:last-of-type) {
  margin-right: 43px;
}
/*# sourceMappingURL=colors.component.css.map */
